import { createStore } from "vuex";

export const storeWriting = createStore({
  state: {
    // currentEssayStructureModule: JSON.parse(localStorage.getItem('module') || {module: 'beginner'}),
    uniqueId: 0, //Global variable equivalent to most recent feedback obj id to access feedback w/o exposing id parameters
    moduleVersion: "Beginners", //Function is the same as above, ONLY mutated upon pressing finsih on an essay
    prompts: [
      {
        prompt:
          "In the late twentieth century, the spread of free-market economic ideas led to numerous changes around the world. Develop an argument that evaluates the extent to which the spread of free-market ideas led to economic change during this period.",
        period: "1900-present",
        type: "Change & Continuity",
        id: "AAA001"
      },
      {
        prompt:
          "In the period circa 1750 to 1900, industrialization led to significant transformations in societies around the world. Develop an argument that evaluates the extent to which industrialization caused social change during this period.",
        period: "1750-1900",
        type: "Causation",
        id: "AAA002"
      },
      {
        prompt:
          "In the period 1200 to 1450, long-distance trade networks such as the Silk Roads and Indian Ocean networks connected different regions. Develop an argument that evaluates the extent to which these trade networks led to cultural exchange.",
        period: "1200-1450",
        type: "Causation",
        id: "AAA003"
      },
      {
        prompt:
          "In the period circa 1450 to 1750, states used a variety of methods to consolidate and maintain power. Develop an argument that evaluates the extent to which religion played a role in state-building during this period.",
        period: "1450-1750",
        type: "Causation",
        id: "AAA004"
      },
      {
        prompt:
          "Develop an argument that evaluates the extent to which long-distance trade networks facilitated cultural exchange in Afro-Eurasia from 1200 to 1450.",
        period: "1200-1450",
        type: "Causation",
        id: "AAA005"
      },
      {
        prompt:
          "States relied on a variety of methods to maintain power in the early modern era. Develop an argument that evaluates the extent to which religion was the most important factor in state-building from 1450 to 1750.",
        period: "1450-1750",
        type: "Causation",
        id: "AAA006"
      },
      {
        prompt:
          "Develop an argument that evaluates the extent to which twentieth-century wars contributed to the rise of new political ideologies.",
        period: "1900-present",
        type: "Causation",
        id: "AAA007"
      },
      {
        prompt:
          "Develop an argument that evaluates the extent to which decolonization movements achieved political and economic independence in the twentieth century.",
        period: "1900-present",
        type: "Change & Continuity",
        id: "AAA008"
      }
    ],
    selectedPrompt: null, // most current selected prompt, RESETS upon accessing the chose prompt page, UPDATES on prompt click
    completedPrompts: [], // note: intended to have the same structure as promptTemplates but filled w/ user input
    promptTemplates: [
      {
        prompt_id: "AAA001",
        templates: {
          thesis:
            "During the time period between __(date)__ and __(date)__ in __(geographic location)__ there were significant changes in __(AP Theme)__ such as __(category)__, __(category)__, and __(category)__.",
          evidence: [
            [
              "During the time period __(date)__ to __(date)__,  __(world context: what event was occurring)__ causing many things to stay constant because ____(why did this event allow continuities?)___.",
              ""
            ],
            [
              "During the time period __(date)__ to __(date)__,  __(world context: what event was occurring)__ causing many things to stay constant because ____(why did this event allow continuities?)___.",
              ""
            ]
          ],
          contextualization: "",
          conclusion: ""
        }
      },
      {
        prompt_id: "AAA002",
        templates: {
          thesis:
            "During the time period between __(date)__ and __(date)__ in __(geographic location)__ there were significant changes in __(AP Theme)__ such as __(category)__, __(category)__, and __(category)__.",
          evidence: [
            [
              "During the time period __(date)__ to __(date)__,  __(world context: what event was occurring)__ causing many things to stay constant because ____(why did this event allow continuities?)___.",
              ""
            ],
            [
              "During the time period __(date)__ to __(date)__,  __(world context: what event was occurring)__ causing many things to stay constant because ____(why did this event allow continuities?)___.",
              ""
            ]
          ],
          contextualization: "",
          conclusion: ""
        }
      },
      {
        prompt_id: "AAA003",
        templates: {
          thesis:
            "During the time period between __(date)__ and __(date)__ in __(geographic location)__ there were significant changes in __(AP Theme)__ such as __(category)__, __(category)__, and __(category)__.",
          evidence: [
            [
              "During the time period __(date)__ to __(date)__,  __(world context: what event was occurring)__ causing many things to stay constant because ____(why did this event allow continuities?)___.",
              ""
            ],
            [
              "During the time period __(date)__ to __(date)__,  __(world context: what event was occurring)__ causing many things to stay constant because ____(why did this event allow continuities?)___.",
              ""
            ]
          ],
          contextualization: "",
          conclusion: ""
        }
      },
      {
        prompt_id: "AAA004",
        templates: {
          thesis:
            "During the time period between __(date)__ and __(date)__ in __(geographic location)__ there were significant changes in __(AP Theme)__ such as __(category)__, __(category)__, and __(category)__.",
          evidence: [
            [
              "During the time period __(date)__ to __(date)__,  __(world context: what event was occurring)__ causing many things to stay constant because ____(why did this event allow continuities?)___.",
              ""
            ],
            [
              "During the time period __(date)__ to __(date)__,  __(world context: what event was occurring)__ causing many things to stay constant because ____(why did this event allow continuities?)___.",
              ""
            ]
          ],
          contextualization: "",
          conclusion: ""
        }
      },
      {
        prompt_id: "AAA005",
        templates: {
          thesis:
            "During the time period between __(date)__ and __(date)__ in __(geographic location)__ there were significant changes in __(AP Theme)__ such as __(category)__, __(category)__, and __(category)__.",
          evidence: [
            [
              "During the time period __(date)__ to __(date)__,  __(world context: what event was occurring)__ causing many things to stay constant because ____(why did this event allow continuities?)___.",
              ""
            ],
            [
              "During the time period __(date)__ to __(date)__,  __(world context: what event was occurring)__ causing many things to stay constant because ____(why did this event allow continuities?)___.",
              ""
            ]
          ],
          contextualization: "",
          conclusion: ""
        }
      },
      {
        prompt_id: "AAA006",
        templates: {
          thesis:
            "During the time period between __(date)__ and __(date)__ in __(geographic location)__ there were significant changes in __(AP Theme)__ such as __(category)__, __(category)__, and __(category)__.",
          evidence: [
            [
              "During the time period __(date)__ to __(date)__,  __(world context: what event was occurring)__ causing many things to stay constant because ____(why did this event allow continuities?)___.",
              ""
            ],
            [
              "During the time period __(date)__ to __(date)__,  __(world context: what event was occurring)__ causing many things to stay constant because ____(why did this event allow continuities?)___.",
              ""
            ]
          ],
          contextualization: "",
          conclusion: ""
        }
      },
      {
        prompt_id: "AAA007",
        templates: {
          thesis:
            "During the time period between __(date)__ and __(date)__ in __(geographic location)__ there were significant changes in __(AP Theme)__ such as __(category)__, __(category)__, and __(category)__.",
          evidence: [
            [
              "During the time period __(date)__ to __(date)__,  __(world context: what event was occurring)__ causing many things to stay constant because ____(why did this event allow continuities?)___.",
              ""
            ],
            [
              "During the time period __(date)__ to __(date)__,  __(world context: what event was occurring)__ causing many things to stay constant because ____(why did this event allow continuities?)___.",
              ""
            ]
          ],
          contextualization: "",
          conclusion: ""
        }
      },
      {
        prompt_id: "AAA008",
        templates: {
          thesis:
            "During the time period between __(date)__ and __(date)__ in __(geographic location)__ there were significant changes in __(AP Theme)__ such as __(category)__, __(category)__, and __(category)__.",
          evidence: [
            [
              "During the time period __(date)__ to __(date)__,  __(world context: what event was occurring)__ causing many things to stay constant because ____(why did this event allow continuities?)___.",
              ""
            ],
            [
              "During the time period __(date)__ to __(date)__,  __(world context: what event was occurring)__ causing many things to stay constant because ____(why did this event allow continuities?)___.",
              ""
            ]
          ],
          contextualization: "",
          conclusion: ""
        }
      },
      {
        prompt_id: "sample",
        templates: {
          thesis:
            "During the time period between __(date)__ and __(date)__ in __(geographic location)__ there were significant changes in __(AP Theme)__ such as __(category)__, __(category)__, and __(category)__.",
          evidence: [
            [
              "During the time period __(date)__ to __(date)__,  __(world context: what event was occurring)__ causing many things to stay constant because ____(why did this event allow continuities?)___.",
              ""
            ],
            [
              "During the time period __(date)__ to __(date)__,  __(world context: what event was occurring)__ causing many things to stay constant because ____(why did this event allow continuities?)___.",
              ""
            ]
          ],
          contextualization: "",
          conclusion: ""
        }
      }
    ],
    feedback: []
  },
  getters: {
    getPrompts: state => state.prompts,
    getUniqueId: state => {
      state.uniqueId++;
      return state.uniqueId;
    },
    parseFeedbackAsTemplate: state => i => {
      const matches = state.feedback.filter(
        feed => feed.prompt_id === i.id && feed.moduleVersion === i.version
      );
      if (matches.length > 0) {
        const feedback = [...matches].sort((a, b) => {
          const aId = Number(a.id) || 0;
          const bId = Number(b.id) || 0;
          return bId - aId;
        })[0];
        console.log("this is the one we're parsing: ", feedback);
        let completedTemplate = {
          prompt_id: feedback.prompt_id,
          promptText: feedback.promptText || null,
          moduleVersion: feedback.moduleVersion,
          templates: {
            raw: feedback.content.raw,
            thesis: feedback.content.thesis.userInput,
            evidence: [],
            contextualization: feedback.content.contextualization.userInput,
            conclusion: feedback.content.conclusion.userInput
          }
        };
        feedback.content.evidence.forEach(x => {
          completedTemplate.templates.evidence.push([
            x.evidence.userInput,
            x.analysis.userInput
          ]);
        });
        console.log(
          "successfully implemented feedback parsing as template",
          completedTemplate
        );
        return [completedTemplate];
      }
      return [];
    },
    findPrompt: (state, getters) => i => {
      //Prioritizes returning the completed user input over the original blank templates, completed user input is injected into textareas to save progress

      //NOTE: for both feedback and timed module, needing to use both findPrompt and findFeedback causes redundant returning of user input,
      //      split findPrompt functionality into a function that solely returns prompt, and one that solely returns template
      if (i === null) {
        return null;
      }
      const completedPromptres = getters.parseFeedbackAsTemplate(i);
      const promptres = state.prompts.filter(prompt => prompt.id === i.id);
      const templateres = state.promptTemplates.filter(
        template => template.prompt_id === i.id
      );
      const basePrompt = promptres[0] || { id: i.id, prompt: "" };
      const hydratedPrompt =
        completedPromptres.length > 0 && completedPromptres[0].promptText
          ? { ...basePrompt, prompt: completedPromptres[0].promptText }
          : basePrompt;

      return completedPromptres.length > 0
        ? { prompt: hydratedPrompt, template: completedPromptres[0] }
        : { prompt: hydratedPrompt, template: templateres[0] };
    },
    findFeedback: state => i => {
      const feedback = state.feedback.filter(
        feed =>
          feed.id.toString() === i.id.toString() &&
          feed.moduleVersion === i.version
      );
      console.log(feedback, state.uniqueId, state.feedback, i);
      if (!feedback.length) {
        return 202;
      }
      return feedback[0];
    }
  },
  mutations: {
    selectPrompt(state, payload) {
      if (payload === state.selectedPrompt) {
        state.selectedPrompt = null;
      } else {
        state.selectedPrompt = payload;
      }
    },
    unselectPrompt(state) {
      state.selectedPrompt = null;
    },
    changeVersion(state, payload) {
      state.moduleVersion = payload;
    },
    uploadUserInput(state, payload) {
      console.log("payload", payload);
      // Overrides/Updates existing feedback object if exists and has an equivalent prompt id
      // Updates uniqueID to connect to existing feedback obj if exists
      //    -  uniqueID functions to identify the feedback obj without being exposed to user manipulation like route params would
      let index = state.feedback.findIndex(
        x =>
          x.prompt_id === payload.prompt_id &&
          x.moduleVersion === payload.moduleVersion
      );
      console.log("apparent index ", state.feedback[index]);
      if (index > -1) {
        //set uniqueID
        state.uniqueId = state.feedback[index].id;
        //UPDATE 8/10/23: bug fix, set new inputs to userInput property of content fields instead of the entire field
        //NOTE: || statement will preserve old labels if no new labelled section is sent, change statement if not intended/desired
        state.feedback[index].content.contextualization.userInput =
          payload.contextualization ||
          state.feedback[index].content.contextualization.userInput;
        state.feedback[index].content.thesis.userInput =
          payload.thesis || state.feedback[index].content.thesis.userInput;
        state.feedback[index].content.conclusion.userInput =
          payload.conclusion ||
          state.feedback[index].content.conclusion.userInput;
        state.feedback[index].promptText =
          payload.promptText || state.feedback[index].promptText || null;

        if (payload.moduleVersion === "Expert") {
          state.feedback[index].labelled =
            payload.labelled || state.feedback[index].labelled;
          state.feedback[index].content.raw =
            payload.raw || state.feedback[index].content.raw;
        }

        //Compatible with a dynamic amount of evidence
        for (let i in payload.evidence) {
          if (i > state.feedback[index].content.evidence.length - 1) {
            //adds new evidences when more is present
            const new_evidence = {
              evidence: {
                userInput: payload.evidence[i][0],
                good: null,
                toImprove: null
              },
              analysis: {
                userInput: payload.evidence[i][1],
                good: null,
                toImprove: null
              }
            };
            state.feedback[index].content.evidence.push(new_evidence);
          } else {
            //overrides previous evidences
            state.feedback[index].content.evidence[i].evidence.userInput =
              payload.evidence[i][0] || null;
            state.feedback[index].content.evidence[i].analysis.userInput =
              payload.evidence[i][1] || null;
          }
        }
      } else {
        const userInput = {
          id: payload.id,
          prompt_id: payload.prompt_id,
          promptText: payload.promptText || null,
          moduleVersion: payload.moduleVersion,
          feedback_given: false,
          labelled: payload.moduleVersion !== "Expert",
          score: null,
          content: {
            contextualization: {
              userInput: payload.contextualization || null,
              good: null,
              toImprove: null
            },
            thesis: {
              userInput: payload.thesis || null,
              good: null,
              toImprove: null
            },
            evidence: [],
            conclusion: {
              userInput: payload.conclusion || null,
              good: null,
              toImprove: null
            }
          }
        };

        userInput.content.raw = payload.raw || null;
        (payload.evidence || []).forEach(x => {
          const new_evidence = {
            evidence: {
              userInput: x[0],
              good: null,
              toImprove: null
            },
            analysis: {
              userInput: x[1],
              good: null,
              toImprove: null
            }
          };
          userInput.content.evidence.push(new_evidence);
        });
        state.feedback.push(userInput);
      }
    },
    applyBackendFeedback(state, payload) {
      const index = state.feedback.findIndex(
        x =>
          x.prompt_id === payload.prompt_id &&
          x.moduleVersion === payload.moduleVersion
      );

      if (index < 0) {
        return;
      }

      const existing = state.feedback[index];
      const backendFeedback = payload.feedback || {};
      const thesisFeedback =
        backendFeedback.sections && backendFeedback.sections.thesis
          ? backendFeedback.sections.thesis
          : {};

      if (existing.content && existing.content.thesis) {
        existing.content.thesis.userInput =
          thesisFeedback.whatWasWritten || existing.content.thesis.userInput;
        existing.content.thesis.good =
          thesisFeedback.whatWasGood || existing.content.thesis.good;
        existing.content.thesis.toImprove =
          thesisFeedback.whatToImprove || existing.content.thesis.toImprove;
      }

      existing.feedback_given = true;
      existing.score =
        backendFeedback.overallScore !== undefined
          ? backendFeedback.overallScore
          : existing.score;
      existing.displayScore =
        backendFeedback.displayScore ?? existing.displayScore ?? null;
      existing.backendFeedback = backendFeedback;
    }
  },
  actions: {
    setSelectedPrompt({ commit }, payload) {
      commit("selectPrompt", payload);
    },
    unSetSelectedPrompt({ commit }) {
      commit("unselectPrompt");
    },
    setUserInput({ commit }, payload) {
      commit("uploadUserInput", payload);
    },
    setModuleVersion({ commit }, payload) {
      commit("changeVersion", payload);
    },
    setBackendFeedback({ commit }, payload) {
      commit("applyBackendFeedback", payload);
    }
  }
});

export default storeWriting;
